import type { ApplicationEditions } from '@atlassian/jira-shared-types/src/edition.tsx';
import { useTenantContext } from '../tenant-context';

export const useAppEditions = (): ApplicationEditions => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.appEditions;
};
